module.exports = __webpack_public_path__ + "img/1XpHX9L_mYcxLvdfnj-xHuMQFiQhSz_PJ.e125a29e.png";